<div style="display: block;margin-inline-start:10px">
    <div class="prop-caption-sub">Required</div>
    <label class="switch">
        <input type="checkbox" [(ngModel)]="required" (ngModelChange)="handleRequiredChange($event)"
            [ngModelOptions]="{standalone: true}">
        <span class="slider round"></span>
    </label>
</div>